import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const loginUser = localStorage.getItem("loginuser");

  // If NOT logged in → go to signin
  if (!loginUser) {
    return <Navigate to="/signin" replace />;
  }

  return children;
};

export default ProtectedRoute;
